export default __webpack_public_path__ + "static/media/dole-lemonade-bg-tablet.4ecbd571.png";